<div class="modal-body scroll-panel w-100-p h-adjust-px">
    <form [formGroup]="fmUser" autocomplete="off" class="scroll-panel h-100-p">
        <div class="row mt-2">
            <div class="col-sm-9">
                <div class="flex justify-content-space-between">
                    <span class="fw-bold title-modal-detail fz-14-px">
                        {{ 'cae-user.lblNewUser' | translate }}
                    </span>
                </div>
                <div class="line-h-blue-purple-dialogs mt-2 mb-3"></div>
            </div>
            <div class="col-sm-3">
                <p class="fz-11-px">* {{ 'common.lblsAreRequired' | translate }}</p>
            </div>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblFullName' | translate}}
                    </mat-label>
                    <input matInput maxlength="50" [formControl]="fmDet.name">
                    <mat-error *ngIf="fmDet.name.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                    <mat-error *ngIf="fmDet.name.hasError('minlength')">
                        {{ 'companies.txtNameMinlength' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblEmail' | translate}}
                    </mat-label>
                    <input matInput maxlength="50" [formControl]="fmDet.email">
                    <mat-error *ngIf="fmDet.email.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                    <mat-error *ngIf="fmDet.email.hasError('pattern')">
                        {{'companies.txtContactEmailPattern' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblPhone' | translate}}
                    </mat-label>
                    <input matInput maxlength="12" [formControl]="fmDet.phone">
                    <mat-error *ngIf="fmDet.phone.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                    <mat-error *ngIf="fmDet.phone.hasError('pattern')">
                        {{'companies.txtContactPhonePattern' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

             <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                    <label class="d-block lbl-radios">
                        {{ 'common.lblStatus' | translate }}
                    </label>
                    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                        [formControl]="fmDet.rbStatusId">
                        <mat-radio-button class="example-radio-button mr-2" *ngFor="let item of catStatus"
                            [value]="item.value">
                            {{item.name}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>





            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblGroup' | translate}}
                    </mat-label>
                    <mat-select [formControl]="fmDet.userGroupId">
                        <mat-option *ngFor="let item of this.listUserGroup"
                            value="{{item.id}}">{{item.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="fmDet.userGroupId.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblAccessGroup' | translate}}
                    </mat-label>
                    <mat-select [formControl]="fmDet.accessGroupId">
                        <mat-option *ngFor="let item of this.listAccessGroup"
                            value="{{item.id}}">{{item.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="fmDet.accessGroupId.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblJobTitle' | translate}}
                    </mat-label>
                    <input matInput maxlength="50" [formControl]="fmDet.job_title">
                    <mat-error *ngIf="fmDet.job_title.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                    <mat-error *ngIf="fmDet.job_title.hasError('pattern')">
                        {{'companies.txtContactJobTitlePattern' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblDepartment' | translate}}
                    </mat-label>
                    <input matInput maxlength="50" [formControl]="fmDet.department">
                    <mat-error *ngIf="fmDet.department.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>


            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>{{ 'cae-user.lblPeriodStartDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="periodStartDate" formControlName="periodStartDate" readonly="true">
                    <mat-datepicker-toggle matIconSuffix [for]="periodStartDate"></mat-datepicker-toggle>
                    <mat-datepicker #periodStartDate></mat-datepicker>
                    <mat-error *ngIf="fmDet.periodStartDate.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblPeriodStartHour' | translate}}
                    </mat-label>
                    <input class="input-w88" matInput maxlength="10" [formControl]="fmDet.periodStartHour"
                        [matMenuTriggerFor]="hoursListMenu" readonly="true">
                    <button type="button" class="btn-none mat-focus-indicator" [matMenuTriggerFor]="hoursListMenu">
                        <i class="fa-regular fa-clock"></i>
                    </button>
                    <mat-error *ngIf="fmDet.periodStartHour.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <mat-menu #hoursListMenu="matMenu">
                <ng-container *ngFor="let hour of hourList">
                    <button mat-menu-item (click)="setHour(hour,'periodStartHour')">
                        <span>{{hour}}</span>
                    </button>
                </ng-container>
            </mat-menu>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>{{ 'cae-user.lblPeriodEndDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="periodEndDate" formControlName="periodEndDate" readonly="true">
                    <mat-datepicker-toggle matIconSuffix [for]="periodEndDate"></mat-datepicker-toggle>
                    <mat-datepicker #periodEndDate></mat-datepicker>
                    <mat-error *ngIf="fmDet.periodEndDate.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'cae-user.lblPeriodEndHour' | translate}}
                    </mat-label>
                    <input class="input-w88" matInput maxlength="5" [formControl]="fmDet.periodEndHour"
                        [matMenuTriggerFor]="hoursListMenu2" readonly="true">
                    <button type="button" class="btn-none mat-focus-indicator" [matMenuTriggerFor]="hoursListMenu2">
                        <i class="fa-regular fa-clock"></i>
                    </button>
                    <mat-error *ngIf="fmDet.periodEndHour.hasError('required')">
                        {{ 'common.lblErrorRequired' | translate}}
                    </mat-error>

                </mat-form-field>
                <mat-menu #hoursListMenu2="matMenu">
                    <ng-container *ngFor="let hour of hourList">
                        <button mat-menu-item (click)="setHour(hour, 'periodEndHour')">
                            <span>{{hour}}</span>
                        </button>
                    </ng-container>
                </mat-menu>
            </div>

            <div class="col-md-6">
                <div>
                    <span class="lbl-control-custom">{{ 'cae-user.lblPhoto' | translate}}</span>
                    <span class="ml-2 lbl-required-info">*</span>
                    <br>
                    <input #fileInput type="file" (change)="onFileSelected($event)" hidden
                        accept="image/png, image/jpeg" />
                    <button class="btnInput-upload-file" (click)="fileInput.click()">
                        <div class="input-file-container">
                            <span class="lbl-input-file" *ngIf="this.photo != null ">{{ this.photo.name }}</span>
                            <span class="lbl-input-file" *ngIf="this.photo == null ">
                                {{ 'cae-user.lblNoFileSelected' | translate}}
                            </span>
                        </div>
                        <i class="ml-4 fa-solid fa-arrow-up-from-bracket"></i>
                    </button>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <div class="mt-4">
                    <img *ngIf="this.photoPreview != null" [src]="this.photoPreview" class="img-photo-preview" />
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-secondary" data-dismiss="modal" (click)="onClose(0)">
        {{ 'common.btnCancel' | translate }}
    </button>
    <button [disabled]="this.fmUser.invalid" (click)="onSave()" class="btn btn-primary" type="submit">
        {{ 'common.btnSave' | translate }}
    </button>
</div>


<ng-container *ngIf="isConfirmationDialog">
    <app-confirmation-dialog [confirmationDialog]="confirmationDialog"
        (onConfirmDialog)="orchestratorCloseDialog($event)"></app-confirmation-dialog>
</ng-container>